import * as ActionTypes from './ActionTypes';

// Migrate the legacy credentials entry without carrying its password forward.
// Only the username is needed to restore the header display after a reload.
const getStoredUsername = () => {
  let username = localStorage.getItem('username');
  const legacyCreds = localStorage.getItem('creds');

  if (!username && legacyCreds) {
    try {
      const legacyUser = JSON.parse(legacyCreds);
      if (legacyUser && typeof legacyUser.username === 'string') {
        username = legacyUser.username;
      }
    } catch (error) {
      // Ignore malformed legacy credentials and remove them below.
    }
  }

  localStorage.removeItem('creds');
  if (username) {
    localStorage.setItem('username', username);
  } else {
    localStorage.removeItem('username');
  }

  return username ? { username } : null;
};

const storedUsername = getStoredUsername();

// The auth reducer. The starting state sets authentication
// based on a token being in local storage. In a real app,
// we would also want a util to check if the token is expired.
export const Auth = (
  state = {
    isLoading: false,
    isAuthenticated: localStorage.getItem('token') ? true : false,
    token: localStorage.getItem('token'),
    refreshToken: localStorage.getItem('refreshToken'),
    user: storedUsername,
    id: localStorage.getItem('id'),
    // ? JSON.parse(localStorage.getItem('id'))
    // : null,
    errMess: null,
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.LOGIN_REQUEST:
      return {
        ...state,
        isLoading: true,
        isAuthenticated: false,
        user: action.username ? { username: action.username } : null,
      };
    case ActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        errMess: '',
        token: action.token,
        id: action.id,
      };
    case ActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        errMess: action.message,
      };
    case ActionTypes.SIGNUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        isAuthenticated: false,
        user: action.username ? { username: action.username } : null,
      };
    case ActionTypes.SIGNUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        errMess: '',
        token: action.token,
      };
    case ActionTypes.SIGNUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        errMess: action.message,
      };
    case ActionTypes.LOGOUT_REQUEST:
      return { ...state, isLoading: true, isAuthenticated: true };
    case ActionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        token: '',
        refreshToken: '',
        user: null,
        id: null,
      };
    case ActionTypes.PWCHANGE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isAuthenticated: true,
        user: action.username ? { username: action.username } : null,
      };
    case ActionTypes.PWCHANGE_SUCCESS:
      return {
        ...state,
        isLoading: true,
        isAuthenticated: true,
        errMess: '',
        token: action.token,
      };
    case ActionTypes.PWCHANGE_FAILURE:
      return {
        ...state,
        isLoading: true,
        isAuthenticated: true,
        errMess: action.message,
      };
    case ActionTypes.TOKEN_REFRESH_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.TOKEN_REFRESH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        token: action.token,
        refreshToken: action.refreshToken,
        id: action.id,
        errMess: '',
      };
    case ActionTypes.TOKEN_REFRESH_FAILURE:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        token: '',
        refreshToken: '',
        errMess: action.message,
      };
    default:
      return state;
  }
};
